import Cookiebot from './Cookiebot';
import { onConsent, onDecline, hasConsent } from './utils';

export default Cookiebot;
export { onConsent, onDecline, hasConsent };
